import * as Sentry from '@sentry/react';
import { getConfig } from '@tcs/client-portal/config/configService';

class Logger {
  loggingEnabled: boolean;

  constructor() {
    this.loggingEnabled = getConfig().SENTRY_LOGGING_ENABLED === 'true';
    const sentryDsn = getConfig().SENTRY_DSN;

    if (this.loggingEnabled) {
      Sentry.init({
        dsn: sentryDsn,
        integrations: [Sentry.browserTracingIntegration()],
        environment: process.env.NODE_ENV,
      });
    }
  }

  logError = (error: Error) => {
    if (this.loggingEnabled) {
      Sentry.captureException(error);
    }
  };

  logInfo = (info: string) => {
    if (this.loggingEnabled) {
      Sentry.captureMessage(info);
    }
  };
}

export { Logger };
